/**
 * Get slug
 * @param {string} string
 * @returns {string}
 */
export default (string) => {
	return string ? string.toLowerCase().replace(/\s+/g, '-') : '';
};
